module.exports = __webpack_public_path__ + "static/media/comforte_logo.07ebf6ef.png";